import { RefObject, useLayoutEffect, useState } from 'react';

function isElementBiggerThan(element: Element | null, maxWidth: number) {
  if (!element) {
    return false;
  }
  return element.clientWidth > maxWidth;
}

export function useContainerQuery(
  ref: RefObject<Element | null>,
  maxWidth: number
) {
  const [isBigger, setIsBigger] = useState(() =>
    isElementBiggerThan(ref.current, maxWidth)
  );

  useLayoutEffect(() => {
    const node = ref.current;

    setIsBigger(isElementBiggerThan(node, maxWidth));

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];

      if (entry) {
        setIsBigger(isElementBiggerThan(entry.target, maxWidth));
      }
    });

    if (node) {
      resizeObserver.observe(node);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [ref, maxWidth]);

  return isBigger;
}
